import { useContractPermissions } from 'commerce-contract-lib/hooks/useContractPermissions';
import { useAllowedActions } from './useAllowedActions';
import { ContractActions } from '../types';
import { ActionValidationError } from '../utils/constants';
import { useMemo } from 'react';
import { useContractData } from '../../../hooks/useFetchContractData';
import { isCPQContract } from '../utils/utilities';
export function useCommonValidation({
  objectId,
  objectTypeId,
  actionID,
  skip
}) {
  var _contractData$propert2;
  const {
    data,
    loading: allowedActionsLoading
  } = useAllowedActions({
    objectId,
    objectTypeId
  }, {
    skip
  });
  const {
    data: contractData,
    loading: contractDataLoading
  } = useContractData({
    objectId,
    objectTypeId
  }, {
    skip
  });
  const permissions = useContractPermissions({
    objectId,
    objectTypeId,
    skip
  });
  return useMemo(() => {
    var _contractData$propert, _data$actionStatuses;
    if (skip) {
      return {
        actionID,
        enabled: false,
        disabledReasons: new Set([ActionValidationError.UNAVAILABLE])
      };
    }
    if (allowedActionsLoading || contractDataLoading) {
      return {
        actionID,
        enabled: false,
        disabledReasons: new Set([ActionValidationError.LOADING])
      };
    }
    if (permissions.isJitaUser()) {
      return {
        actionID,
        enabled: false,
        disabledReasons: new Set([ActionValidationError.JITA_USER])
      };
    }
    if (!permissions.hasWrite()) {
      return {
        actionID,
        enabled: false,
        disabledReasons: new Set([ActionValidationError.UNAUTHORIZED])
      };
    }
    const isCPQ = isCPQContract(contractData === null || contractData === void 0 || (_contractData$propert = contractData.properties) === null || _contractData$propert === void 0 || (_contractData$propert = _contractData$propert.hs_object_source) === null || _contractData$propert === void 0 ? void 0 : _contractData$propert.value);
    if (!isCPQ && actionID !== ContractActions.DELETE_CONTRACT) {
      return {
        actionID,
        enabled: false,
        disabledReasons: new Set([ActionValidationError.UNAVAILABLE])
      };
    }
    if (isCPQ && actionID === ContractActions.DELETE_CONTRACT) {
      return {
        actionID,
        enabled: false,
        disabledReasons: new Set([ActionValidationError.UNAVAILABLE])
      };
    }
    const maybeStatus = data === null || data === void 0 || (_data$actionStatuses = data.actionStatuses) === null || _data$actionStatuses === void 0 ? void 0 : _data$actionStatuses.find(status => status.action === actionID);
    return maybeStatus ? {
      actionID: maybeStatus.action,
      enabled: maybeStatus.enabled,
      disabledReasons: new Set(maybeStatus.disabledReasons)
    } : {
      actionID,
      enabled: true,
      disabledReasons: new Set()
    };
  }, [actionID, allowedActionsLoading, contractData === null || contractData === void 0 || (_contractData$propert2 = contractData.properties) === null || _contractData$propert2 === void 0 || (_contractData$propert2 = _contractData$propert2.hs_object_source) === null || _contractData$propert2 === void 0 ? void 0 : _contractData$propert2.value, contractDataLoading, data === null || data === void 0 ? void 0 : data.actionStatuses, permissions, skip]);
}